<template>
  <v-card id="account-setting-card">
    <!-- tabs -->
    <v-tabs
      v-model="tab"
      show-arrows
    >
      <v-tab
        v-for="tab in tabs"
        :key="tab.icon"
      >
        <v-icon
          size="20"
          class="me-3"
        >
          {{ tab.icon }}
        </v-icon>
        <span>{{ tab.title }}</span>
      </v-tab>
    </v-tabs>

    <!-- tabs item -->
    <v-tabs-items v-model="tab">
      <v-tab-item>
        <account-settings-account :accountdata="accountSettingData"></account-settings-account>
      </v-tab-item>

      <v-tab-item>
        <account-settings-security></account-settings-security>
      </v-tab-item>

      <v-tab-item>
        <account-settings-info></account-settings-info>
      </v-tab-item>
    </v-tabs-items>
  </v-card>
</template>

<script>
import {
  mdiAccountOutline, mdiLockOpenOutline, mdiInformationOutline, mdiAccountGroupOutline,
} from '@mdi/js'
import { ref } from '@vue/composition-api'

// demos
import AccountSettingsAccount from './AccountSettingsAccount.vue'
import AccountSettingsSecurity from './AccountSettingsSecurity.vue'
import AccountSettingsInfo from './AccountSettingsInfo.vue'

export default {
  components: {
    AccountSettingsAccount,
    AccountSettingsSecurity,
    AccountSettingsInfo,
  },
  data() {
    const tab = ref('')

    return {
      tab,
      tabs: [],
      accountSettingData: {
        name: '',
        email: '',
        phone: '',
        level_user: '',
        img: '',
      },
      icons: {
        mdiAccountOutline,
        mdiLockOpenOutline,
        mdiInformationOutline,
        mdiAccountGroupOutline,
      },
    }
  },
  mounted() {
    this.accountSettingData = this.$store.state.user

    if (this.$store.state.user.level_user === 'Admin') {
      this.tabs = [
        { title: 'Account', icon: mdiAccountOutline },
        { title: 'Security', icon: mdiLockOpenOutline },
        { title: 'User Account', icon: mdiAccountGroupOutline },
      ]
    } else {
      this.tabs = [
        { title: 'Account', icon: mdiAccountOutline },
        { title: 'Security', icon: mdiLockOpenOutline },
      ]
    }
  },
}
</script>
